module.exports = __webpack_public_path__ + "img/218.e335e4ef.jpg";